import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-destination-download-field',
  templateUrl: './destination-download-field.component.html',
  styleUrls: ['./destination-download-field.component.scss']
})
export class DestinationDownloadFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
